let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2zQPP")).then(() => parcelRequire('2xmbt'));